import Login from './Components/Login/Login.jsx';
import Dashboard from './Components/Dashboard/Dashboard.jsx';
import ZoomOAuthCallback from './Components/Zoom/ZoomOAuthCallback.jsx';
import ResearchApplicantsPage from './Components/Research/ResearchApplicantsPage.jsx';
import LazyTestAccountsPage from './Components/TestAccounts/LazyTestAccountsPage.jsx';
import { IS_STAGING_TOOLS_ENABLED } from './global/Environment';

/**
 * Routes Array
 * Same properties should match for all attributes
 */
const routes = [
  {
    path: '/',
    exact: true,
    component: Login,
    private: false
  },
  // Private Routes
  {
    path: '/dashboard',
    exact: true,
    component: Dashboard,
    private: true
  },
  {
    path: '/research/:studySlug/applicants',
    exact: true,
    component: ResearchApplicantsPage,
    private: true
  },
  ...(IS_STAGING_TOOLS_ENABLED
    ? [
        {
          path: '/test-accounts',
          exact: true,
          component: LazyTestAccountsPage,
          private: true
        }
      ]
    : []),
  {
    path: '/zoom/oauth/callback',
    exact: true,
    component: ZoomOAuthCallback,
    private: true
  }
];

export default routes;
